import { PAGES_SERVICE } from "@/services/pages.service.js";
import router from '@/router/index';

const state = { listOutput: null, detailOutput: null };

const actions = {
    getList({ dispatch, commit }, inputGetPages) {
        dispatch('alert/clear', null, { root: true });
        commit('listRequest');
        
        PAGES_SERVICE.list(inputGetPages)
            .then(
                output => {
                    commit('listSuccess', output);
                },
                error => {
                    commit('listFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    getDetails({ dispatch, commit }, slug) {
        dispatch('alert/clear', null, { root: true });
        commit('listDetailRequest');
        
        PAGES_SERVICE.getDetail(slug)
            .then(
                output => {
                    commit('listDetailSuccess', output);
                },
                error => {
                    commit('listDetailFailure', error);
                    dispatch('alert/error', error, { root: true });
                    router.push({ name: '404' });
                }
            );
    },
};

const mutations = {
    /* List */
    listRequest(state) {
        state.listOutput = null;
    },
    listSuccess(state, output) {
        state.listOutput = output;
    },
    listFailure(state) {
        state.listOutput = false;
    },
    /* Detail */
    listDetailRequest(state) {
        state.detailOutput = null;
    },
    listDetailSuccess(state, output) {
        state.detailOutput = output
    },
    listDetailFailure(state) {
        state.detailOutput = false;
    },
};

export const pages = {
    namespaced: true,
    state,
    actions,
    mutations
};